import { z } from 'zod';

export const PART2_NACHVERSAND_STATES = ['BOOKED', 'MISSED'] as const;
export type Part2NachversandState = (typeof PART2_NACHVERSAND_STATES)[number];

export const PART2_NACHVERSAND_HISTORY_STATUSES = [
  'DISPATCHED',
  'RETURNED',
  'PICKED_UP',
] as const;
export type Part2NachversandHistoryStatus =
  (typeof PART2_NACHVERSAND_HISTORY_STATUSES)[number];

// The participant's own Part 2 Nachversand. Blinded on purpose: only PART2 rows, never a BDM
// row, no kind, no cycle number and nothing derived from bdmTreatment.
export const participantNachversandResDto = z.object({
  // cohortType CONVENIENT_ACCESS and nachversandEligible === true; otherwise current is null and
  // history empty
  eligible: z.boolean(),
  // The open cycle with a booked call. MISSED = the call's day (Europe/Zurich) is over and
  // nothing was posted yet.
  current: z
    .object({
      state: z.enum(PART2_NACHVERSAND_STATES),
      appointment: z.object({
        id: z.string(),
        startTime: z.coerce.date(),
        endTime: z.coerce.date(),
        joinUrl: z.string(),
      }),
    })
    .nullable(),
  // the posted cycles, newest first
  history: z.array(
    z.object({
      date: z.coerce.date(),
      status: z.enum(PART2_NACHVERSAND_HISTORY_STATUSES),
    }),
  ),
});
export type ParticipantNachversandResDto = z.infer<
  typeof participantNachversandResDto
>;
